import { Routes } from '@angular/router';
import { EventWidgetComponent } from './components/event-widget/event-widget.component';
import { ProgressEventComponent } from './components/progress-event-widget/progress-event-widget.component';

export const routes: Routes = [
  {
    path: 'event/:eventId',
    component: EventWidgetComponent
  },
  {
    path: 'progress-event/:eventId',
    component: ProgressEventComponent
  },
];
